import * as yup from "yup";

/**
 * Validation schema for practice branch (used in Add/Update Branch modals)
 */
export const branchSchema = yup.object().shape({
  address: yup
    .string()
    .required("Address is required")
    .max(255, "Address must be 255 characters or less"),
  street: yup
    .string()
    .required("Street is required")
    .max(255, "Street must be 255 characters or less"),
  city: yup
    .string()
    .required("City is required")
    .max(100, "City must be 100 characters or less"),
  state: yup
    .string()
    .required("State is required")
    .max(100, "State must be 100 characters or less"),
  zip: yup
    .string()
    .required("ZIP code is required")
    .matches(/^\d{5}$/, "ZIP code must be exactly 5 digits"),
  emailAddress: yup
    .string()
    .required("Email address is required")
    .email("Must be a valid email")
    .max(255, "Email must be 255 characters or less"),
  primaryPhoneNumber: yup
    .string()
    .required("Primary phone number is required")
    .matches(
      /^\d{1,15}$/,
      "Phone number must contain only digits (1-15 characters)"
    ),
  faxNumber: yup
    .string()
    .optional()
    .matches(
      /^\d{0,10}$/,
      "Fax number must contain only digits (up to 10 characters)"
    ),
});

export type BranchFormData = yup.InferType<typeof branchSchema>;
